import * as styles from './styles.css';
import { Button as MUIButton, CircularProgress, FormHelperText } from '@mui/material';
import { atom } from 'jotai/vanilla';
import { useAtom, useAtomValue, useSetAtom } from 'jotai/react';
import atoms from '../../atoms';
import { segmentFeatureFlag, hireVueLinkFeatureFlag } from '../../atoms/featureFlag';
import { IFrame } from '../../interfaces';
import { useFlags as useLaunchDarklyFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

export interface ISubmitProps {
  id?: string;
}

const submit = {
  state: atom(
    (get) => {
      const is_in_review = get(atoms.application.is_in_review);
      const is_loading = get(atoms.api.is_loading);
      const error = get(atoms.error.message);
      const frame_label = (get(atoms.frame.data) as IFrame).button;
      const is_frame_label_valid = frame_label !== undefined && frame_label !== '';
      const label = is_in_review ? 'Save Changes' : is_frame_label_valid ? frame_label : 'Submit';
      return { label, error, is_loading };
    },
    (get, set) => {
      const check_error = set(atoms.error.check);
      const has_error = check_error !== '';
      if (!has_error) {
        set(atoms.api.is_loading, true);
        set(atoms.application.is_in_review, false);
        return set(atoms.answers.submit);
      }
      set(atoms.api.is_loading, false);
    },
  ),
};

const Submit = ({ id }: ISubmitProps) => {
  const { frames } = useAtomValue<IFrame>(atoms.frame.data);
  const [{ label, error, is_loading }, onClick] = useAtom(submit.state) as [
    { label: string; error: string; is_loading: boolean },
    () => void,
  ];
  const label_type = label.length > 10 ? styles.label_long : styles.label_short;
  const button_class = is_loading ? styles.button_loading : `${styles.button_loaded} ${label_type}`;
  const error_class = error ? styles.show_error : styles.hide_error;
  const launchDarklyFlags = useLaunchDarklyFlags();
  const segment_flag = launchDarklyFlags['tutors-1413-segment-amplitude-poc'];
  const hireVueLinkEnabled = launchDarklyFlags['MOESRC-153-hireview-link-in-thank-you-page'];
  const setSegmentFeatureFlag = useSetAtom(segmentFeatureFlag);
  const setHireVueLinkFeatureFlag = useSetAtom(hireVueLinkFeatureFlag);

  useEffect(() => {
    setSegmentFeatureFlag(segment_flag);
  }, [segment_flag, setSegmentFeatureFlag]);

  useEffect(() => {
    setHireVueLinkFeatureFlag(hireVueLinkEnabled);
  }, [hireVueLinkEnabled, setHireVueLinkFeatureFlag]);

  return (
    <>
      {!!frames?.length && (
        <>
          <div className={styles.button_container}>
            <MUIButton variant={'contained'} id={id} className={button_class} onClick={onClick}>
              {!is_loading && label}
              {is_loading && <CircularProgress className={styles.loading} />}
            </MUIButton>
          </div>
          <FormHelperText className={error_class} error={!!error}>
            {error}
          </FormHelperText>
        </>
      )}
    </>
  );
};

export default Submit;
